import { motion } from 'framer-motion'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { SectionHeading } from '@/components/ui/SectionHeading'

interface TreatmentBenefitsSectionProps {
  title?: string
  subtitle?: string
  items: string[]
  className?: string
}

export function TreatmentBenefitsSection({
  title,
  subtitle,
  items,
  className,
}: TreatmentBenefitsSectionProps) {
  if (!items || items.length === 0) return null

  return (
    <section className={cn('bg-primary-soft py-16 md:py-24', className)}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          title={title || ''}
          subtitle={subtitle}
          centered
        />

        <ul
          className={cn(
            'grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6',
            title && 'mt-10 md:mt-12'
          )}
        >
          {items.map((item, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="flex items-start gap-4 p-4 rounded-xl bg-white border border-primary/10 shadow-sm"
            >
              <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary">
                <Check className="h-3.5 w-3.5" strokeWidth={3} />
              </span>
              <span className="text-sm md:text-base leading-relaxed text-muted">
                {item}
              </span>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  )
}
